"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOptionsReducer = void 0;
const filterOptions_1 = require("../actions/filterOptions");
const initState = {};
const filterOptionsReducer = (filterOptions = initState, action) => {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case filterOptions_1.SET_FILTER_OPTIONS:
            return Object.assign({}, action.payload);
        default:
            return filterOptions;
    }
};
exports.filterOptionsReducer = filterOptionsReducer;
//# sourceMappingURL=filterOptions.reducer.js.map